// Imported first in main.js: ES imports run in order, so this starts Sentry
// before the router and store modules run and can report a crash in them.
// Initialising further down main.js missed every error thrown while booting.
import Vue from 'vue'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { isDevHost } from "@/utils/devHost";
import { IGNORED_ERROR_PATTERNS } from "@/utils/ignoredErrors";

const MAX_EVENTS_PER_PAGE = 10
let sentCount = 0

Sentry.init({
  Vue,
    environment: process.env.NODE_ENV,
  release: process.env.__GIT_SHA__,

  tracingOptions: {
    trackComponents: true,
  },
  dsn: "https://ed984dbc0e06408ca9567437b34019fd@o251030.ingest.sentry.io/1436710",
  integrations: [new Integrations.BrowserTracing()],

  // Sample 10% of transactions in production, 0% on localhost (tracesSampler
  // replaces tracesSampleRate and is supported in Sentry v6)
  tracesSampler: function() {
    if (isDevHost()) {
      return 0
    }
    return 0.1
  },

  // On local dev: log errors to console instead of sending to Sentry
  beforeSend(event, hint) {
    if (isDevHost()) {
      var error = hint && hint.originalException
      console.error('[Sentry (dev)]', error || event)
      return null
    }
    // At most MAX_EVENTS_PER_PAGE errors per page load. Custom rate limits on
    // the key need Sentry's Business plan. ~8 400 errors on 30 Sep-1 Oct 2026
    // (PostHog saw 31 that week, so probably one client looping) emptied the quota.
    if (sentCount >= MAX_EVENTS_PER_PAGE) {
      return null
    }
    sentCount++
    return event
  },

  // Shared with PostHog — see src/utils/ignoredErrors.js
  ignoreErrors: IGNORED_ERROR_PATTERNS,
});
